import { useState } from 'react';
import {
  FlexContainer,
  TootltipText
} from '../../Container/InboxV2/ScheduledMessages/styles.schudledmessages';
import { clickToCopy, truncateText } from '../../Container/InboxV2/inboxUtils';
import Badge from '../../globalcomponents/Badge';
import { BadgeWrapper } from './styles.maximisedpnawidget';

const MAX_VISIBLE_AMENITIES = 2;

const AmenitiesColumn = ({ rowData }) => {
  const amenitiesArray = Array.isArray(rowData.amenities)
    ? rowData.amenities
    : [];
  const visibleAmenities = amenitiesArray.slice(0, MAX_VISIBLE_AMENITIES);
  const hiddenAmenities = amenitiesArray.slice(MAX_VISIBLE_AMENITIES);

  return (
    <BadgeWrapper>
      {visibleAmenities.map((amenity, index) => {
        return <AmenityBadge key={index} amenity={amenity} />;
      })}
      {hiddenAmenities.length > 0 && (
        <MoreAmenitiesBadge amenities={hiddenAmenities} />
      )}
    </BadgeWrapper>
  );
};

const AmenityBadge = ({ amenity }) => {
  const truncatedText = truncateText(amenity, 15);

  const initialTooltipText = (
    <FlexContainer style={{ padding: '5px' }}>
      <TootltipText>*Click the pill to copy</TootltipText>
      <TootltipText>{amenity}</TootltipText>
    </FlexContainer>
  );

  const [tooltipContent, setTooltipContent] = useState(initialTooltipText);

  const handleClick = event => {
    event.stopPropagation();
    clickToCopy(amenity);
    setTooltipContent('Copied!');
    setTimeout(() => {
      setTooltipContent(initialTooltipText);
    }, 2000);
  };

  return (
    <Badge
      background="rgba(196,196,196,0.5)"
      color="#393939"
      borderRadius="40px"
      onClick={handleClick}
      items={[amenity]}
      tooltipJsx={tooltipContent}
    >
      {truncatedText}
    </Badge>
  );
};

const MoreAmenitiesBadge = ({ amenities }) => {
  const tooltipContent = (
    <FlexContainer style={{ padding: '5px' }}>
      <TootltipText>More amenities</TootltipText>
      <TootltipText>{amenities.join(', ')}</TootltipText>
    </FlexContainer>
  );

  return (
    <Badge
      background="rgba(196,196,196,0.5)"
      color="#393939"
      borderRadius="40px"
      items={amenities}
      tooltipJsx={tooltipContent}
    >
      +{amenities.length}
    </Badge>
  );
};

export default AmenitiesColumn;
